module.exports = __webpack_public_path__ + "img/rws-logo.338d4714.svg";